exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-arrows .arrow_l a[data-v-6d83a6e8],.small-arrows .arrow_r a[data-v-6d83a6e8]{padding:1rem 1rem;padding-margin-top:-3rem;right:-3rem}.small-arrows .arrow_l a[data-v-6d83a6e8]{right:auto;left:-3rem}", ""]);

// exports
